import {REDUCE_SET_CALL_INSTANCE, REDUCE_SET_CALLING_STATUS, REDUCE_SET_CALL_SYSTEM_STATUS, REDUCE_SET_CALL_INIT_STATUS, REDUCE_SET_CALL_PLATFORM_STATUS,REDUCE_SET_CALLING_ID, REDUCE_SET_WARNING} from '../types';

export const setCallInstance = (data: any) => {
    return {
        type: REDUCE_SET_CALL_INSTANCE,
        data
    };
};

export const setCallIngStatus = (data: any) => {
    return {
        type: REDUCE_SET_CALLING_STATUS,
        data
    };
};

export const setCallSystemStatus = (data: any) => {
    return {
        type: REDUCE_SET_CALL_SYSTEM_STATUS,
        data
    };
};

export const setCallInitStatus = (data: any) => {
    return {
        type: REDUCE_SET_CALL_INIT_STATUS,
        data
    };
};

export const setCallPlatformStatus = (data: any) => {
    return {
        type: REDUCE_SET_CALL_PLATFORM_STATUS,
        data
    };
};

export const setCallingId = (data: any) => {
    return {
        type: REDUCE_SET_CALLING_ID,
        data
    };
};
export const setWarningMessage = (data: {type:string, message:string}) => {
    return {
        type: REDUCE_SET_WARNING,
        data
    };
};